import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType, WorkflowComponentParameterMode } from '../types';
import { SelectWorkflowComponent } from './common/selectcomponent';
const methods = {};
methods[Provider.BigQuery] = new Map([
    ['max', 'MAX($1) $1_max'],
    ['min', 'MIN($1) $1_min'],
    ['sum', 'SUM($1) $1_sum'],
    ['count', 'COUNT($1) $1_count'],
    ['count_distinct', 'COUNT(DISTINCT $1) $1_count_distinct'],
    ['concat', 'STRING_AGG($1) $1_concat'],
    ['avg', 'AVG($1) $1_avg'],
    ['combine', 'ST_UNION_AGG($1) $1_union'],
    ['any', 'ANY_VALUE($1) $1_any'],
    ['array', 'ARRAY_AGG($1) $1_array'],
    ['centroid', 'ST_CENTROID_AGG($1) $1_centroid'],
    ['makeline', 'ST_MAKELINE(ARRAY_AGG($1)) $1_makeline'],
    ['convexhull', 'ST_CONVEXHULL(ST_UNION_AGG($1)) $1_convexhull']
]);
methods[Provider.Snowflake] = new Map([
    ['max', 'MAX($1) $1_max'],
    ['min', 'MIN($1) $1_min'],
    ['sum', 'SUM($1) $1_sum'],
    ['count', 'COUNT($1) $1_count'],
    ['count_distinct', 'COUNT(DISTINCT $1) $1_count_distinct'],
    ['concat', "LISTAGG($1, ',') $1_concat"],
    ['avg', 'AVG($1) $1_avg'],
    ['combine', 'ST_COLLECT($1) $1_union'],
    ['any', 'ANY_VALUE($1) $1_any'],
    ['array', 'ARRAY_AGG($1) $1_array']
]);
methods[Provider.Postgres] = new Map([
    ['max', 'MAX($1) $1_max'],
    ['min', 'MIN($1) $1_min'],
    ['sum', 'SUM($1) $1_sum'],
    ['count', 'COUNT($1) $1_count'],
    ['count_distinct', 'COUNT(DISTINCT $1) $1_count_distinct'],
    ['concat', "STRING_AGG($1, ',') $1_concat"],
    ['avg', 'AVG($1) $1_avg'],
    ['combine', 'ST_COLLECT($1) $1_union'],
    ['any', 'COALESCE($1) $1_any'],
    ['array', 'ARRAY_AGG($1) $1_array'],
    ['centroid', 'ST_CENTROID(ST_COLLECT($1)) $1_centroid'],
    ['makeline', 'ST_MAKELINE(ARRAY_AGG($1)) $1_makeline'],
    ['convexhull', 'ST_CONVEXHULL(ST_COLLECT($1)) $1_convexhull']
]);
methods[Provider.Redshift] = new Map([
    ['max', 'MAX($1) $1_max'],
    ['min', 'MIN($1) $1_min'],
    ['sum', 'SUM($1) $1_sum'],
    ['count', 'COUNT($1) $1_count'],
    ['count_distinct', 'COUNT(DISTINCT $1) $1_count_distinct'],
    ['concat', "LISTAGG(CAST($1 AS TEXT), ',') $1_concat"],
    ['avg', 'AVG($1) $1_avg'],
    ['combine', 'ST_COLLECT($1) $1_union'],
    ['any', 'ANY_VALUE($1) $1_any'],
    ['array', `JSON_PARSE('"[' || listagg($1, ',') || ']"') $1_array`],
    ['centroid', 'ST_CENTROID(ST_COLLECT($1)) $1_centroid'],
    ['convexhull', 'ST_CONVEXHULL(ST_COLLECT($1)) $1_convexhull']
]);
methods[Provider.DatabricksRest] = new Map([
    ['max', 'MAX($1) $1_max'],
    ['min', 'MIN($1) $1_min'],
    ['sum', 'SUM($1) $1_sum'],
    ['count', 'COUNT($1) $1_count'],
    ['count_distinct', 'COUNT(DISTINCT $1) $1_count_distinct'],
    ['concat', `CONCAT_WS(',', COLLECT_LIST($1)) $1_concat'`],
    ['avg', 'AVG($1) $1_avg'],
    ['combine', 'ST_UNION_AGG($1) $1_union'],
    ['any', 'ANY_VALUE($1) $1_any'],
    ['array', 'ARRAY_AGG($1) $1_array'],
    [
        'centroid',
        'ST_ASWKB(ST_CENTROID(ST_UNION_AGG(ST_GEOMFROMWKB($1)))) $1_centroid'
    ],
    [
        'makeline',
        'ST_ASWKB(ST_MAKELINE(ARRAY_AGG(ST_GEOMFROMWKB($1)))) $1_makeline'
    ],
    [
        'convexhull',
        'ST_ASWKB(ST_CONVEXHULL(ST_UNION_AGG(ST_GEOMFROMWKB($1)))) $1_convexhull'
    ]
]);
const methodDataTypes = {};
methodDataTypes[Provider.BigQuery] = new Map([
    ['max', ColumnDataType.Number],
    ['min', ColumnDataType.Number],
    ['sum', ColumnDataType.Number],
    ['count', ColumnDataType.Number],
    ['count_distinct', ColumnDataType.Number],
    ['concat', ColumnDataType.String],
    ['avg', ColumnDataType.Number],
    ['combine', ColumnDataType.Geography],
    ['array', ColumnDataType.String],
    ['centroid', ColumnDataType.Geography],
    ['makeline', ColumnDataType.Geography],
    ['convexhull', ColumnDataType.Geometry]
]);
methodDataTypes[Provider.Snowflake] = new Map([
    ['max', ColumnDataType.Number],
    ['min', ColumnDataType.Number],
    ['sum', ColumnDataType.Number],
    ['count', ColumnDataType.Number],
    ['count_distinct', ColumnDataType.Number],
    ['concat', ColumnDataType.String],
    ['avg', ColumnDataType.Number],
    ['combine', ColumnDataType.Geography],
    ['array', ColumnDataType.String]
]);
methodDataTypes[Provider.Postgres] = new Map([
    ['max', ColumnDataType.Number],
    ['min', ColumnDataType.Number],
    ['sum', ColumnDataType.Number],
    ['count', ColumnDataType.Number],
    ['count_distinct', ColumnDataType.Number],
    ['concat', ColumnDataType.String],
    ['avg', ColumnDataType.Number],
    ['combine', ColumnDataType.Geometry],
    ['array', ColumnDataType.String],
    ['centroid', ColumnDataType.Geometry],
    ['makeline', ColumnDataType.Geometry],
    ['convexhull', ColumnDataType.Geometry]
]);
methodDataTypes[Provider.Redshift] = new Map([
    ['max', ColumnDataType.Number],
    ['min', ColumnDataType.Number],
    ['sum', ColumnDataType.Number],
    ['count', ColumnDataType.Number],
    ['count_distinct', ColumnDataType.Number],
    ['concat', ColumnDataType.String],
    ['avg', ColumnDataType.Number],
    ['combine', ColumnDataType.Geography],
    ['array', ColumnDataType.String],
    ['centroid', ColumnDataType.Geography],
    ['convexhull', ColumnDataType.Geometry]
]);
methodDataTypes[Provider.DatabricksRest] = new Map([
    ['max', ColumnDataType.Number],
    ['min', ColumnDataType.Number],
    ['sum', ColumnDataType.Number],
    ['count', ColumnDataType.Number],
    ['count_distinct', ColumnDataType.Number],
    ['concat', ColumnDataType.String],
    ['avg', ColumnDataType.Number],
    ['combine', ColumnDataType.Geography],
    ['array', ColumnDataType.String],
    ['centroid', ColumnDataType.Geography],
    ['makeline', ColumnDataType.Geography],
    ['convexhull', ColumnDataType.Geometry]
]);
class GroupBy extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.groupby',
            group: 'Aggregation',
            title: 'Group by',
            description: `
      This component creates a new table with aggregated values.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'columns',
                type: WorkflowComponentParamType.SelectColumnAggregation,
                title: 'Aggregation',
                parent: 'source',
                placeholder: 'workflows.parameterForm.selectAField',
                allowExpression: false
            },
            {
                name: 'groupby',
                type: WorkflowComponentParamType.Column,
                title: 'Group by',
                parent: 'source',
                mode: WorkflowComponentParameterMode.Multiple,
                value: undefined,
                dataType: [
                    ColumnDataType.Boolean,
                    ColumnDataType.Number,
                    ColumnDataType.String,
                    ColumnDataType.Date,
                    ColumnDataType.Datetime,
                    ColumnDataType.Time,
                    ColumnDataType.Timestamp
                ],
                noDefault: true,
                maxSelectionsCount: Infinity
            }
        ]);
    }
    getInnerSql({ envVars, params, connection }) {
        const tokens = (params.columns ?? '')
            .split(',')
            .map((x) => x.trim());
        const stats = [];
        for (let index = 0; index < tokens.length; index += 2) {
            stats.push(methods[connection.type].get(tokens[index + 1])
                ?.replace(/\$1/g, tokens[index])
                ?.replace(/\$ATLOCATION/g, connection.quoteName(envVars.analyticsToolboxDataset)));
        }
        const groupByStr = Array.isArray(params.groupby)
            ? params.groupby.join(',\n')
            : params.groupby;
        if (connection.type === Provider.DatabricksRest) {
            return dedent `SELECT /*+ REPARTITION(40) */
              ${groupByStr},
              ${stats.join(',\n')}
            FROM ${connection.quoteName(params.source)}
            GROUP BY ${groupByStr}`;
        }
        else {
            return dedent `SELECT ${groupByStr},
              ${stats.join(',\n')}
            FROM ${connection.quoteName(params.source)}
            GROUP BY ${groupByStr}`;
        }
    }
    getUIProperties(provider) {
        const classifiedMethods = {};
        classifiedMethods[ColumnDataType.String] = [
            'concat',
            'count',
            'any',
            'array'
        ];
        classifiedMethods[ColumnDataType.Number] = [
            'min',
            'max',
            'avg',
            'sum',
            'count',
            'any',
            'array'
        ];
        classifiedMethods[ColumnDataType.Boolean] = [
            'count',
            'count_distinct',
            'any'
        ];
        classifiedMethods[ColumnDataType.Date] = [
            'min',
            'max',
            'count',
            'count_distinct',
            'any'
        ];
        classifiedMethods[ColumnDataType.Datetime] = [
            'min',
            'max',
            'count',
            'count_distinct',
            'any'
        ];
        classifiedMethods[ColumnDataType.Time] = [
            'min',
            'max',
            'count',
            'count_distinct',
            'any'
        ];
        classifiedMethods[ColumnDataType.Timestamp] = [
            'min',
            'max',
            'count',
            'count_distinct',
            'any'
        ];
        switch (provider) {
            case Provider.BigQuery:
                classifiedMethods[ColumnDataType.Geometry] = ['count', 'any', 'array'];
                classifiedMethods[ColumnDataType.Geography] = [
                    'combine',
                    'count',
                    'any',
                    'array',
                    'centroid',
                    'makeline',
                    'convexhull'
                ];
                break;
            case Provider.Snowflake:
                classifiedMethods[ColumnDataType.Geometry] = ['count', 'any', 'array'];
                classifiedMethods[ColumnDataType.Geography] = [
                    'combine',
                    'count',
                    'any',
                    'array'
                ];
                break;
            case Provider.Redshift:
                classifiedMethods[ColumnDataType.Geometry] = [
                    'combine',
                    'count',
                    'any',
                    'array',
                    'centroid',
                    'convexhull'
                ];
                classifiedMethods[ColumnDataType.Geography] = ['count', 'any', 'array'];
                break;
            case Provider.Postgres:
                classifiedMethods[ColumnDataType.Geometry] = [
                    'combine',
                    'count',
                    'any',
                    'array',
                    'centroid',
                    'makeline',
                    'convexhull'
                ];
                classifiedMethods[ColumnDataType.Geography] = ['count', 'any', 'array'];
                break;
            case Provider.DatabricksRest:
                classifiedMethods[ColumnDataType.Geometry] = [
                    'combine',
                    'count',
                    'any',
                    'array',
                    'centroid',
                    'makeline',
                    'convexhull'
                ];
                classifiedMethods[ColumnDataType.Geography] = ['count', 'any', 'array'];
                break;
        }
        return {
            methods: classifiedMethods
        };
    }
    getVersion(provider) {
        return '1';
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns, params, connection }) {
        const tokens = (params.columns ?? '')
            .split(',')
            .map((x) => x.trim());
        const statColumns = [];
        for (let index = 0; index < tokens.length; index += 2) {
            const colName = methods[connection.type]
                .get(tokens[index + 1])
                ?.split(' ')
                .pop()
                ?.replace(/\$1/g, tokens[index]);
            let colType;
            if (tokens[index + 1]?.includes('any')) {
                colType = columns.source.find((x) => x.name === tokens[index])
                    ?.type;
            }
            else {
                colType = methodDataTypes[connection.type].get(tokens[index + 1]);
            }
            statColumns.push({
                name: colName,
                type: colType
            });
        }
        const groupBy = Array.isArray(params.groupby)
            ? params.groupby
            : [params.groupby];
        const groupByColumns = groupBy
            .map((x) => columns.source.find((y) => y.name === x))
            .filter((x) => x != undefined);
        const allColumns = [...groupByColumns, ...statColumns];
        return allColumns;
    }
}
export { GroupBy };
